import React from 'react';
import RothIRACalculator from '../components/calculators/RothIRACalculator';
import FAQ from '../components/FAQ';
import SEO from '../components/shared/SEO';

const RothIRAPage: React.FC = () => {
  const faqs = [
    {
      question: "What is a Roth IRA?",
      answer: "A Roth IRA is an individual retirement account where you contribute after-tax dollars. The money grows tax-free, and qualified withdrawals in retirement are tax-free."
    },
    {
      question: "What are the contribution limits?",
      answer: "For 2024, you can contribute up to $7,000 to a Roth IRA. If you're 50 or older, you can make an additional $1,000 catch-up contribution."
    },
    {
      question: "Are there income limits?",
      answer: "Yes, your ability to contribute to a Roth IRA phases out at higher income levels. For 2024, the phase-out range for single filers is $146,000-$161,000, and for married filing jointly it's $230,000-$240,000."
    },
    {
      question: "What are the withdrawal rules?",
      answer: "You can withdraw your contributions at any time without penalty. Earnings can be withdrawn tax-free and penalty-free if you're 59½ or older and have held the account for at least 5 years."
    },
    {
      question: "How is a Roth IRA different from a traditional IRA?",
      answer: "The main difference is tax treatment. Traditional IRA contributions are tax-deductible, but withdrawals are taxed. Roth IRA contributions are made with after-tax dollars, but qualified withdrawals are tax-free."
    }
  ];

  return (
    <>
      <SEO 
        title="Roth IRA Growth Calculator"
        description="Calculate your tax-free retirement growth with our Roth IRA calculator. Project contributions and optimize your savings strategy."
        keywords={[
          'Roth IRA calculator',
          'tax-free retirement',
          'Roth IRA contributions',
          'retirement planning',
          'IRA calculator',
          'retirement savings',
          'tax-free growth',
          'Roth conversion',
          'retirement account',
          'IRA limits'
        ]}
      />
      <RothIRACalculator />
      <FAQ faqs={faqs} />
    </>
  );
};

export default RothIRAPage;